import { RouteObject } from "react-router-dom";
import HomePage from "../pages/home/page";
import AboutPage from "../pages/about/page";
import ServicesPage from "../pages/services/page";
import GamesGuildsPage from "../pages/games-guilds/page";
import PortfolioPage from "../pages/portfolio/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  { path: "/", element: <HomePage /> },
  { path: "/about", element: <AboutPage /> },
  { path: "/services", element: <ServicesPage /> },
  { path: "/games-guilds", element: <GamesGuildsPage /> },
  { path: "/portfolio", element: <PortfolioPage /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
